import { Classroom } from '@/api/classroom'

const state = () => ({
    videos: [],
    videoPagination: 0,
    video: null,
    LoadingVideo: false,
    isSuccessVideo: true,
    messageVideo: '',
    savedIdClassroomVideo: 0,
})

const getters = {
    videoList: state => state.videos,
    video: state => state.video,
    videoPagination: state => state.videoPagination,
    isLoadingVideo: state => state.isLoadingVideo,
    isSuccessVideo: state => state.isSuccessVideo,
    messageVideo: state => state.messageVideo,
    savedIdClassroomVideo: state => state.savedIdClassroomVideo,
}

const actions = {
    async fetchAllVideos({ commit }, id) {
        commit('setVideoIsLoading', true)
        commit('setSavedIdClassroomVideo', id)
        commit('setVideoPagination', 0)
        await Classroom.videoList(id)
            .then(response => {
                commit('setVideos', response.data.data)

                commit('setVideoIsLoading', false)
            })
            .catch(error => {
                console.log(error)
                commit('setVideoIsLoading', false)
            })
    },
    updateFrom({ commit }, from) {
        // console.log('dr vuex', from)
        commit('setVideoPagination', from)
    },
    async fetchDetailVideo({ commit }, id) {
        commit('setVideoIsLoading', true)
        await Classroom.videoDetail(id)
            .then(response => {
                // console.log(response)
                commit('setVideoDetail', response.data.data)
                commit('setVideoIsLoading', false)
            })
            .catch(error => {
                console.log(error)
                commit('setVideoIsLoading', false)
            })
    },
    async updateVideo({ commit }, video) {
        const id = video.id
        const payload = video.payload

        await Classroom.editVideo(id, payload)
            .then(response => {
                if (response.data.success) {
                    commit('setSuccessVideo', true)
                    commit('setMessageVideo', 'Berhasil Mengubah Video')
                } else {
                    commit('setSuccessVideo', false)
                    commit('setMessageVideo', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessVideo', false)
                commit('setMessageVideo', error.errors[0].message)
            })
    },
    async addVideo({ commit }, payload) {
        await Classroom.addVideo(payload)
            .then(res => {
                if (res.data.success) {
                    commit('setSuccessVideo', true)
                    commit('setMessageVideo', 'Berhasil Menambahkan Video')
                } else {
                    commit('setSuccessVideo', false)
                    commit('setMessageVideo', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessVideo', false)
                commit('setMessageVideo', error.errors[0].message)
            })
    },
    async deleteVideo({ commit }, id) {
        // console.log(id)
        await Classroom.videoDelete(id)
            .then(res => {

                if (res.data.success) {
                    commit('setSuccessVideo', true)
                    commit('setMessageVideo', 'Berhasil Menghapus Video')
                } else {
                    commit('setSuccessVideo', false)
                    commit('setMessageVideo', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessVideo', true)
                commit('setMessageVideo', error.errors[0].message)
            })
    },
    async addAssetVideo({commit}, data) {
        await Classroom.createAssetVideo(data.id, data.payload)
        .then(res => {
            if(res.data.success) {
                commit('setSuccessVideo', true)
                commit('setMessageVideo', 'Berhasil Menambahkan Asset')
            } else {
                commit('setSuccessVideo', false)
                commit('setMessageVideo', 'Terjadi Kesalahan')
            }
        })
        .catch(err => {
            commit('setSuccessVideo', false)
            commit('setMessageVideo', err.errors[0].message)
        })
    },
    async removeResolution({commit}, id) {
        await Classroom.deleteResolutionVideo(id)
        .then(res => {
            if(res.data.success) {
                commit('setSuccessVideo', true)
                commit('setMessageVideo', 'Berhasil Menghapus Resolusi Video')
            } else {
                commit('setSuccessVideo', false)
                commit('setMessageVideo', 'Terjadi Kesalahan')
            }
        })
        .catch(err => {
            commit('setSuccessVideo', false)
            commit('setMessageVideo', err.errors[0].message)
        })
    },
}

const mutations = {
    setVideos: (state, videos) => {
        state.videos = videos
    },

    setVideoPagination: (state, videoPagination) => {
        state.videoPagination = videoPagination
    },

    setVideoDetail: (state, video) => {
        state.video = video
    },

    setVideoIsLoading: (state, isLoadingVideo) => {
        state.isLoadingVideo = isLoadingVideo
    },

    setSuccessVideo: (state, isSuccessVideo) => {
        state.isSuccessVideo = isSuccessVideo
    },

    setMessageVideo: (state, messageVideo) => {
        state.messageVideo = messageVideo
    },
    setSavedIdClassroomVideo: (state, savedIdClassroomVideo) => {
        state.savedIdClassroomVideo = savedIdClassroomVideo
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}